import tracker, { trackEvent, trackUser, resetTracker, trackPageView } from './tracker'
import { TrackerEvents } from './types'

export { trackEvent, trackUser, resetTracker, TrackerEvents, trackPageView }
export default tracker
